module.exports = __webpack_public_path__ + "static/media/Shopee.f52b137e.png";